import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import { Row, Col, Button, Label, FormGroup, DefaultSheet, DefaultTable, FormSection, SheetBody, SheetFooter, ButtonIcon } from 'twyne-new.ui';

import Input from 'components/form/Input';
import Select from 'components/form/Select';
import CodeEditor from 'components/form/CodeEditor';
import ColorPicker from 'components/form/ColorPicker';
import HTMLEditorPreview from 'components/HTMLEditorPreview';
import Helmet from 'react-helmet';
import { capitalize } from 'lodash'

import ImageField from './ImageField';
import { Plus, Trash } from 'lucide-react';

class AttributeModal extends React.Component {

  componentWillMount() {
    const attribute = Object.assign({}, this.props.attribute)
    this.setState({ attribute })
  }

  componentDidMount() {
    let optionsObj = this.state.attribute.options

    const optionsArr = optionsObj ? Object.keys(optionsObj).map(option => ({ value: option, label: optionsObj[option] })) : []
    this.setState({ optionsArr })
  }

  handleOnChangeType = (option) => {
    let attribute = this.state.attribute
    attribute.type = option && option.value || null
    this.setState({ attribute })
  }

  handleChangeOptionInput = (index, field, value) => {
    let optionsArr = this.state.optionsArr
    optionsArr[index][field] = value

    this.setState({ optionsArr })
  }

  handleAttributeChange = (value, field, allowSpaces = true) => {
    let attribute = this.state.attribute

    if (!allowSpaces)
      value = value.replace(/\s/g, "_")

    attribute[field] = value
    this.setState({ attribute })
  }

  onAttributeSubmit = (model) => {
    let attribute = { ...model, ...this.state.attribute }
    const optionsArr = this.state.optionsArr

    let options = {}

    for (let opt of optionsArr) {
      options[opt.value] = opt.label
    }
    attribute.options = options

    this.props.handleAttributeValidSubmit(attribute)
  }

  addOption = () => {
    let optionsArr = this.state.optionsArr
    optionsArr.push({ value: '', label: '' })
    this.setState({ optionsArr })
  }

  removeOption = (index) => {
    let optionsArr = this.state.optionsArr
    optionsArr.splice(index, 1);
    this.setState({ optionsArr })
  }

  renderStaticListFields = (optionsArr, attribute) => {
    const options = optionsArr || []
    const tableData = options.map((option, index) => ({ ...option, id: index }))
    const columns = [
      {
        dataField: 'value',
        text: 'Value',
        formatter: (value, row) => <Input
          value={value}
          name="option_value"
          onChange={e => this.handleChangeOptionInput(row.id, 'value', e.target.value)}
          placeholder="Value"
        />,
      },
      {
        dataField: 'label',
        text: 'Label',
        formatter: (value, row) => <Input
          value={value}
          name="option_label"
          onChange={e => this.handleChangeOptionInput(row.id, 'label', e.target.value)}
          placeholder="Label"
        />,
      },
      {
        dataField: 'action',
        text: '',
        className: 'w-8',
        formatter: (_, row) => <ButtonIcon content='Delete' onClick={() => this.removeOption(row.id)}>
          <Trash size='16' />
        </ButtonIcon>,
      },
    ]

    return <>
      <Col size="12" >
        <div className="float-right">
          <Button size="sm" color="accent" onClick={this.addOption}>
            <Plus size={14} />
            Add
          </Button>
        </div>
        <FormSection>
          Options
        </FormSection>
      </Col>
      <Col size="12">
        <DefaultTable
          data={tableData}
          columns={columns}
          noDataIndication={() => ''}
          className="max-h-[25vh] overflow-y-auto"
        />
      </Col>
      {options.length > 0 && <Col size="12">
        <FormGroup>
          <Label>Default Value</Label>
          <Select name="defaultValue" handleOnChange={({ value }) => this.handleAttributeChange(value, 'defaultValue')} options={options.filter(option => option.value !== '')} value={attribute.defaultValue} required />
        </FormGroup>
      </Col>}
    </>
  }

  attributeTypes = [
    {
      label: "String",
      value: "string"
    },
    {
      label: "Select",
      value: "static-list"
    },
    {
      label: 'Image',
      value: "image"
    },
    {
      label: 'HTML',
      value: "html"
    },
    {
      label: 'Text Area',
      value: "large-string"
    },
    {
      label: 'Rich Text',
      value: "html-preview"
    },
    {
      label: 'Color',
      value: "color"
    }
  ]
  sizes = [...Array(12)].map((_, i) => ({ label: i + 1, value: i + 1 }))

  renderAttributeValue = () => {
    const { attribute, optionsArr } = this.state

    switch (attribute.type) {
      case 'static-list':
        return this.renderStaticListFields(optionsArr, attribute);

      case 'large-string':
        return <Col size='12' style={{ zIndex: 1 }}>
          <FormGroup>
            <Label>Content</Label>
            <CodeEditor language='plain' key={attribute.type}
              name="content"
              value={attribute.defaultValue}
              width="100%"
              onChange={value => this.handleAttributeChange(value, 'defaultValue')}
            />
          </FormGroup>
        </Col>
      case 'html':
        return <Col size='12' style={{ zIndex: 1 }}>
          <FormGroup>
            <Label>Content</Label>
            <CodeEditor language='html' key={attribute.type}
              name="content"
              value={attribute.defaultValue}
              width="100%"
              onChange={value => this.handleAttributeChange(value, 'defaultValue')}
            />
          </FormGroup>
        </Col>
      case 'html-preview':
        return <Col size='12' style={{ zIndex: 1 }}>
          <FormGroup>
            <Label>Content</Label>
            <HTMLEditorPreview
              key={attribute.type}
              tabSize='sm'
              toolbarSize='sm'
              value={attribute.defaultValue || ''}
              onChange={value => this.handleAttributeChange(value, 'defaultValue')}
            />
          </FormGroup>
        </Col>
      case 'image':
        return <Col size='12'>
          <FormGroup>
            <Label>Upload image</Label>
            <ImageField value={attribute.defaultValue ? attribute.defaultValue.src : ''} onChange={src => this.handleAttributeChange(src && { src } || null, 'defaultValue')} />
          </FormGroup>
        </Col>
      case 'color':
        return <Col size='12'>
          <FormGroup>
            <Label>Default color</Label>
            <ColorPicker
              value={attribute.defaultValue || ''}
              onChange={value => this.handleAttributeChange(value, 'defaultValue')}
              parser={ColorPicker.parsers.css}
            />
          </FormGroup>
        </Col>

      default:
        return <Col size="12">
          <FormGroup>
            <Label>Default Value</Label>
            <Input value={attribute.defaultValue || ''} name="defaultValue" placeholder="Default"
              onChange={(e) => this.handleAttributeChange(e.target.value, 'defaultValue')}
            />
          </FormGroup>
        </Col>
    }
  }

  render() {

    const { onClickSidebarClose, action } = this.props
    const { attribute } = this.state

    return (
      <DefaultSheet
        contentProps={{ size: 'md' }}
        wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && onClickSidebarClose() }}
        title={`${capitalize(action)} Attribute`}>
        <Formsy onValidSubmit={this.onAttributeSubmit}>
          <SheetBody>
            <Helmet title="Attribute" />
            <Row>
              <Col size="12">
                <FormGroup>
                  <Label>Key</Label>
                  <Input disabled={action === 'edit' && true} value={attribute.key || ''} name="key" placeholder="Key" required
                    onChange={e => this.handleAttributeChange(e.target.value, 'key', false)}
                  />
                </FormGroup>
              </Col>
              <Col size="12">
                <FormGroup>
                  <Label>Label</Label>
                  <Input value={attribute.label || ''} name="label" placeholder="Label" required
                    onChange={e => this.handleAttributeChange(e.target.value, 'label')}
                  />
                </FormGroup>
              </Col>
              <Col size="12">
                <FormGroup>
                  <Label>Type</Label>
                  <Select name="type" handleOnChange={this.handleOnChangeType} options={this.attributeTypes} value={attribute.type} required />
                </FormGroup>
              </Col>
              <Col size="12">
                <FormGroup>
                  <Label>Col Size</Label>
                  <Select name="col_size" handleOnChange={opt => this.handleAttributeChange(opt && opt.value || null, 'col_size')} options={this.sizes} value={attribute.col_size} required />
                </FormGroup>
              </Col>
              {this.renderAttributeValue()}
            </Row>
          </SheetBody>
          <SheetFooter>
            <Button onClick={onClickSidebarClose} variant='ghost'>Cancel</Button>
            <Button type="submit" color="accent">Save</Button>
          </SheetFooter>
        </Formsy>
      </DefaultSheet>
    );
  }
}

AttributeModal.propTypes = {
  onClickSidebarClose: PropTypes.func,
  handleAttributeValidSubmit: PropTypes.func,
  action: PropTypes.string,
  attribute: PropTypes.any,
};

export default AttributeModal;
